import script from "./AutoAIConfirmation.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoAIConfirmation.vue?vue&type=script&setup=true&lang=ts"

import "./AutoAIConfirmation.vue?vue&type=style&index=0&id=74df2269&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74df2269"]])

export default __exports__